import { useLanguage } from "@/contexts/LanguageContext";
import { cn } from "@/lib/utils";

interface NavPricingBadgeProps {
  /** Float absolutely just below the (relative) parent. Default true. */
  floating?: boolean;
  /** "sm" renders a much smaller pill (used in the cramped mobile top bar). */
  size?: "sm" | "md";
  className?: string;
}

const SIZE_CLASSES: Record<"sm" | "md", string> = {
  md: "px-2 py-0.5 text-[9px]",
  sm: "px-1.5 py-0 text-[7px]",
};

/** Eye-catching discount pill shown next to every Pricing nav entry. */
export function NavPricingBadge({
  floating = true,
  size = "md",
  className,
}: NavPricingBadgeProps) {
  const { t } = useLanguage();

  return (
    <span
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-full bg-gradient-to-r from-pink-500 to-rose-500 font-black uppercase tracking-wide text-white shadow-md shadow-pink-500/40",
        SIZE_CLASSES[size],
        floating && "absolute left-1/2 -translate-x-1/2 top-full -mt-2",
        className,
      )}
    >
      {t.pricing.discount20}
    </span>
  );
}
